
export default {
  emits: ['submit'],
  data() {
    return {
      user: null,
      use_aws_email: false
    }
  },
  methods: {
    open(user) {
      this.user = user
      this.use_aws_email = false
      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    submit() {
      this.$emit('submit', this.user.id, {use_aws_email: this.use_aws_email})
      this.close()
    }
  }
}
